import React, { useEffect, useState } from 'react';
import MiningPartsLists from './MiningPartsLists';
import helperfunctions from '../../../utils/helperfunctions';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { useSelector } from 'react-redux';
import partsService from "../../../services/partsservice";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { IMiningPartsInterface } from './IMiningPartsInterface';
import { IAppContextProps } from '../../App/AppInterface';
import { useAppContext } from '../../App/App';

const MiningPartsListscontainer = (props: IMiningPartsInterface) => {

    const { t } = useTranslation();
  const [currentDistributor, setCurrentDistributor] = useState<any>(null);
  const [miningDistributorInfo, setMiningDistributorInfo] = useState<any>({ loading: false, data: {} });
    const { isMixedFleetDistributor, isWacMixedFleetDistributor }: IAppContextProps = useAppContext();
   
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state)
    }));

  const getCommaSeparatedValues = (parts: any[], key: string) => {
    const uniqueValues = new Set(parts.map(part => part?.[key]));
    return Array.from(uniqueValues).join(', ');
  };

  const getMiningDistributorInfo = () => {
      setMiningDistributorInfo({ loading: true, data: {} });
    partsService.getMiningDistributorInfo(globalData?.DistributorCode)
        .then((response: any) => {
        setCurrentDistributor(globalData?.DistributorCode);
        const type = 'csr';
        const filteredContacts = response.filter((contact: any) => contact.contactType.toLowerCase().includes(type));
        const email = getCommaSeparatedValues(filteredContacts, 'email');
        const phone = getCommaSeparatedValues(filteredContacts, 'telephone');
        setMiningDistributorInfo({ loading: false, data: { email, phone } });
      })
        .catch((e: any) => {
        setCurrentDistributor(globalData?.DistributorCode);
        setMiningDistributorInfo({ loading: false, data: { email: '', phone: '' } });
      })
  }

    useEffect(() => {
        if (props?.miningParts?.data?.length > 0 && globalData?.DistributorCode && currentDistributor != globalData?.DistributorCode && (isMixedFleetDistributor || isWacMixedFleetDistributor) && !miningDistributorInfo.loading) {
        getMiningDistributorInfo();
        }
    }, [globalData?.DistributorCode, isMixedFleetDistributor, props?.miningParts]);

    const getMiningPartsErrMsg = (distributor: any) => (
        <div className="mb-2">
            <div className="ErrorMessage_Wrapper">
                <div className="ErrorMessage_card">
                    <span className="fa fa-exclamation-circle mr-1"></span>
                    <span>
                        <span>{t(RESOURCE.MyK_Label_MiningPartsList_ErrorMessage)}</span>
                        <div className="distributorInfo mt-1 text-Wrapper">
                            <span>{`${t(RESOURCE.MyK_Label_ShoppingCart_Email)}: ${distributor?.email || '-'}`}</span>
                        </div>
                        <div className="distributorInfo mt-1 text-Wrapper">
                            <span>{`${t(RESOURCE.Myk_Label_Phone_Number)}: ${distributor?.phone || '-'}`}</span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    );

  return (
      <MiningPartsLists
          getPartsListItems={props.getPartsListItems}
          miningDistributorInfo={miningDistributorInfo}
          getMiningParts={props.getMiningParts}
          miningParts={props.miningParts}
          getMiningPartsErrMsg={getMiningPartsErrMsg}
    />
  )
}

export default MiningPartsListscontainer;